import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import PackagedProductTraceDetailFields from "./PackagedProductTraceDetailFields";

export default function PackagingHistoryDetailPanel(props) {
  const { singleItem, setOpen, onOpenReassign } = props;

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                Packaging record
              </Dialog.Title>
              {/* <p className="mt-1 truncate text-md text-gray-700">
                {singleItem.product_name} ({singleItem.plu})
              </p> */}
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <button
                type="button"
                className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={() => onOpenReassign(singleItem)}
              >
                Reassign
              </button>
              <button
                type="button"
                className="rounded-md bg-white p-2 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
          <PackagedProductTraceDetailFields singleItem={singleItem} />
        </div>
      </div>
    </div>
  );
}
